import styled from "styled-components";
import MultipleSelectionFilter from "./MultipleSelectionFilter/MultipleSelectionFilter";

const Wrapper = styled.div`
  display: flex;
  margin-top: 8px;
  align-items: center;

`

const Input = styled.input`
  border: 1px solid var(--color-border-general);
  padding: 2px 5px;
  outline: none;
  width: 100%;
`

const Container = styled.div`
  max-width: 100%;
  flex-grow: 1;
`

function DefaultColumnFilter(props) {
    const {column: {filterValue, setFilter,id}, enableMultipleSelection} = props;
    const setFreeText = (value) => {
        setFilter({
            ...filterValue,
            freeText: value
        })
    }

    return (
        <Wrapper>
            <Container>
                <Input
                    className={id + "-input"}
                    value={filterValue?.freeText || ''}
                    onChange={e => {
                        setFreeText(e.target.value || undefined) // Set undefined to remove the filter entirely
                    }}
                />
            </Container>
            {
                enableMultipleSelection &&
                <MultipleSelectionFilter column={props.column}/>
            }
        </Wrapper>
    )
}

export default DefaultColumnFilter
